<template>
  <div
    v-if="isStandardBusiness"
    class="mb-2"
  >
    <StandardBusinessParty
      :party="party"
      :label="label"
      v-on="$listeners"
    />
  </div>
  <div
    v-else
    class="mb-2"
  >
    <SingleUserParty
      :party="party"
      :label="label"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import {
  isStandardBusinessAccount
} from '@/dataAccess/accountTypes'
import StandardBusinessParty from './StandardBusinessParty.vue'
import SingleUserParty from './SingleUserParty.vue'

export default {
  name: 'PartyDetails',
  components: {
    StandardBusinessParty,
    SingleUserParty
  },
  props: {
    party: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    isStandardBusiness() {
      return isStandardBusinessAccount(this.party.type)
    }
  }
}
</script>
